import React, {SVGProps} from 'react'
import styled from 'styled-components'
import Box, {BoxProps} from '../layout/Box'

const IconBase = styled(Box).attrs<
  BoxProps & Omit<SVGProps<SVGElement>, 'width' | 'height' | 'color'>
>(props => ({
  as: 'svg',
  display: 'block',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  color: props.color ? props.theme.colors[props.color] : null,
}))<BoxProps & Omit<SVGProps<SVGElement>, 'width' | 'height' | 'color'>>({})

export default IconBase
